import React, { useEffect, useRef, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Phone, Briefcase, BarChart3, Globe } from 'lucide-react';

const Services = () => {
  const { t } = useLanguage();
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const services = [
    {
      icon: Briefcase,
      title: t.services.service1Title,
      description: t.services.service1Desc
    },
    {
      icon: Phone,
      title: t.services.service2Title,
      description: t.services.service2Desc
    },
    {
      icon: BarChart3,
      title: t.services.service3Title,
      description: t.services.service3Desc
    },
    {
      icon: Globe,
      title: t.services.service4Title,
      description: t.services.service4Desc
    }
  ];

  return (
    <section
      id="services"
      ref={sectionRef}
      className="min-h-screen py-20 md:py-32 px-6 bg-white relative overflow-hidden"
    >
      <div className="max-w-6xl mx-auto relative z-10">
        <div className={`text-center mb-12 md:mb-16 transition-all duration-1000 transform ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h2
            className="text-2xl md:text-3xl lg:text-4xl font-bold mb-3 md:mb-4 text-black"
            style={{ fontFamily: 'Crimson Text, serif' }}
          >
            {t.services.title}
          </h2>
          <p className="text-base md:text-xl text-gray-700">
            {t.services.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={index}
                className={`group bg-gray-50 p-6 md:p-10 rounded-xl border border-gray-100 transition-all duration-700 transform text-center min-h-[280px] md:min-h-[320px] flex flex-col justify-center ${
                  isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'
                } hover:-translate-y-2 hover:shadow-2xl hover:border-gray-200`}
                style={{
                  transitionDelay: `${index * 100}ms`
                }}
              >
                <div className="flex justify-center mb-3 md:mb-4">
                  <div className="p-3 md:p-4 bg-black rounded-lg group-hover:scale-110 transition-transform duration-300">
                    <Icon className="text-white" size={24} />
                  </div>
                </div>
                <h3 className="text-xl md:text-2xl font-semibold mb-2 md:mb-3 text-black" style={{ fontFamily: 'Crimson Text, serif' }}>
                  {service.title}
                </h3>
                <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;